import { all, put, call, takeLatest } from "redux-saga/effects";
import {
  showLoading,
  hideLoading,
  showPullToRefresh,
  hidePullToRefresh,
} from "../../actions/Login/action";
import * as constants from "../../utils/constants";
import request from "../../utils/request";
import {
  loadSearchData,
  loadStateCountryCodes,
  setStofData,
} from "../../actions/Search/action";
import { getFavorite } from "../../actions/Favorite/action";
import { DomainConverter } from "../../utils/common";

export function* searchData(data: any) {
  try {
    yield put(showLoading());
    const repos = yield call(request, ["SEARCH", "SEARCH_LOADS"]);
    yield put(loadSearchData(repos.data, false));

    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* searchStateCodes(data: any) {
  try {
    yield put(showLoading());
    const repos = yield call(request, ["COUNTRY_CODES", "COUNTRY_CODES"]);
    yield put(loadStateCountryCodes(repos, false));

    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* favoriteData() {
  try {
    yield put(showLoading());
    const favouriteData = yield call(request, ["FAVORITE", "FAVORITE_LOADS"]);
    yield put(getFavorite(favouriteData));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}
export function* fetchSearchResults(data: any) {
  const { searchParams, isPagination, isHideLoader, callback } = data.payload;
  try {
    if (!(data && data.payload && isHideLoader)) {
      yield put(showLoading());
    }
    yield put(showPullToRefresh());
    const searchReqestQuery = DomainConverter.domainToData<any>(searchParams);
    const fetchSearchResults = yield request<any>([
      "SEARCH",
      "SEARCH",
      null,
      "",
      searchReqestQuery,
      "application/json",
    ]);


    let responseData: any = {};
    responseData = getLoadPostingsDeadHeadFormated(fetchSearchResults, responseData);

    yield put(loadSearchData(responseData, isPagination));
    if (!(data && data.payload && isHideLoader)) {
      yield put(hideLoading());
    }
    yield put(hidePullToRefresh());
    const searchLoadPostingV2Data = getSearchLoadPostingV2Data(fetchSearchResults);
    const status = searchLoadPostingV2Data ? searchLoadPostingV2Data.status : false;
    const message = searchLoadPostingV2Data ? searchLoadPostingV2Data.message : "";
    if (callback) {
      callback(status, message);
    }
  } catch (e) {
    if (!(data && data.payload && isHideLoader)) {
      yield put(hideLoading());
    }
    yield put(hidePullToRefresh());
    if (callback) {
      callback(false);
    }
  }
}

function getSearchLoadPostingV2Data(fetchSearchResults: any) {
  return fetchSearchResults &&
    fetchSearchResults.data &&
    fetchSearchResults.data.searchLoadPostingV2||null;
}

function getLoadPostingsDeadHeadFormated(fetchSearchResults: any, responseData: any) {
  if (checkFetchSearchReultsData(fetchSearchResults)) {
    let loadPostings = fetchSearchResults.data.searchLoadPostingV2.loadPostings || [];
    let loadPostingsDeadHeadFormated = loadPostings && loadPostings.map((loadPosting: any) => { return { ...loadPosting, loadStop: loadPosting.loadStop.map((loadStop: any) => { return { ...loadStop, deadHead: loadStop.deadHead ? parseInt(loadStop.deadHead) : null }; }) || [] }; });
    responseData = {
      searchLoads: loadPostingsDeadHeadFormated || [],
      totalRecords: fetchSearchResults.data.searchLoadPostingV2.totalRecords || 0,
    };
  }
  return responseData;
}

function checkFetchSearchReultsData(fetchSearchResults: any) {
  return fetchSearchResults &&
    fetchSearchResults.data &&
    fetchSearchResults.data.searchLoadPostingV2;
}

export function* searchStofLoads(data: any) {
  const {  callback } = data;
  try {
    yield put(showLoading());
    const query = DomainConverter.domainToData<any>(data.payload);
    const repos = yield call(request, [
      "SEARCH",
      "SEARCH_STOF",
      null,
      "",
      query,
      "application/json",
    ]);
    let loads: any[] = data.oldLoads || [];
    loads = loads.concat(
      (repos.data &&
        repos.data.getStateBasedLoad &&
        repos.data.getStateBasedLoad.loadPostings) ||
        []
    );
    yield put(
      setStofData({
        loadPostings: loads,
        totalRecords:
          repos.data &&
          repos.data.getStateBasedLoad &&
          repos.data.getStateBasedLoad.totalRecords,
        isStofLoaded: true,
      })
    );
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
  finally {
    if(callback) callback();
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(constants.SEARCH_DATA, searchData),
    takeLatest(constants.FETCH_SEARCH_RESULTS, fetchSearchResults),
    takeLatest(constants.GET_STATE_COUNTRY_CODES, searchStateCodes),
    takeLatest(constants.GET_STOF_LOADS, searchStofLoads),
  ]);
}
